import { render, staticRenderFns } from "./MicrosoftSource.vue?vue&type=template&id=6df2b421"
import script from "./MicrosoftSource.vue?vue&type=script&lang=js"
export * from "./MicrosoftSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports